import React from 'react'

export const Loader = () => {
  return (
    <div className='bounding-loader'>
        <div></div>
        <div></div>
        <div></div>
    </div>
  )
}
